export const SHARE_COMPLETE = 'shareComplete'
export const LAST_PULLED = 'lastPulled'
